import { createContext } from "react";

const PasswordContext = createContext(null);

export default PasswordContext;
